import { defineStore } from "pinia";

interface State {
  enabled: boolean;
  photoEditorImage: null | string;
  createNew: boolean;
  editorV2: boolean;
  options: {
    hideControls?: string[];
  };
  AIinEditor: boolean;
}

export const useImageEditorStore = defineStore("imageEditor", {
  state: (): State => ({
    enabled: true,
    photoEditorImage: null,
    createNew: false,
    editorV2: true,
    options: {},
    AIinEditor: false,
  }),
});
